import { Controller } from 'stimulus';
import dataLayer from '../tracking/dataLayer';

class Interpreter extends Controller {
  async connect() {
    if (typeof window.initSqlJs === 'undefined') {
      return;
    }

    this.db = null;

    const SQL = await window.initSqlJs({
      locateFile: (file) => `/front_assets/${file}`,
    });

    const res = await fetch('/storage/courses.sqlite');
    const buffer = await res.arrayBuffer();

    this.db = new SQL.Database(new Uint8Array(buffer));
  }

  interpret() {
    if (!this.db) {
      return;
    }

    const { value } = this.inputTarget;

    try {
      const res = this.db.exec(value);

      this.outputResponse(res);
    } catch (err) {
      this.outputError(err.message);
    }

    const cleanedValue = this.cleanupValue(value)
      .replace(/(\r\n|\n|\r)/gm, '')
      .replace(/\s\s+/g, ' ');

    dataLayer.event('SQL', 'submit', cleanedValue);
  }

  outputError(errorMessage) {
    this.outputTarget.removeAttribute('hidden');
    this.outputTarget.classList.add('is-error');
    this.outputTarget.textContent = errorMessage;
  }

  outputResponse(res) {
    if (typeof res === 'undefined' || !Array.isArray(res)) {
      this.outputError('Unexpected response from database');
      return;
    }

    if (res.length) {
      const responseItem = res[0];

      let table = '<table>';
      table += '<thead>';
      table += '<tr>';
      responseItem.columns.forEach((col) => {
        table += `<th>${this.cleanupValue(col)}</th>`;
      });
      table += '</tr>';
      table += '</thead>';

      table += '<tbody>';
      responseItem.values.forEach((cols) => {
        table += '<tr>';
        cols.forEach((col) => {
          table += `<td>${this.cleanupValue(col)}</td>`;
        });
        table += '</tr>';
      });
      table += '</tbody>';
      table += '</table';

      this.outputTarget.innerHTML = table;
    } else {
      this.outputTarget.innerHTML = 'No response.';
    }

    this.outputTarget.removeAttribute('hidden');
    this.outputTarget.classList.remove('is-error');
  }

  // eslint-disable-next-line class-methods-use-this
  cleanupValue(str) {
    if (typeof str === 'number') {
      return str;
    }

    if (typeof str !== 'string') {
      return '';
    }

    return str.replace(/[^a-z0-9_\s()[]]+/gi, '');
  }
}

Interpreter.targets = [
  'input',
  'output',
];

export default Interpreter;
